// src/components/CaptureSuccessPage.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Result } from 'antd';
// +++ INICIO: AJUSTE VISUAL +++
// Se importa el ícono 'StopOutlined' para dar una mejor retroalimentación visual.
// Se cambia 'CloseCircleOutlined' por 'StopOutlined' para la sesión cancelada.
// +++ FIN: AJUSTE VISUAL +++
import { CheckCircleOutlined, StopOutlined } from '@ant-design/icons';

const CaptureSuccessPage = () => {
  const location = useLocation();
  const wasCancelled = location.state?.cancelled;

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#f0f2f5' }}>
      {wasCancelled ? (
        <Result
          // +++ Se reemplaza el ícono de error por uno más neutral y se cambia el color +++
          icon={<StopOutlined style={{ color: '#8c8c8c' }} />}
          title="Sesión Finalizada"
          subTitle="La sesión de captura de fotos ha sido cerrada. Ya puede cerrar esta ventana."
        />
      ) : (
        <Result
          icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
          title="¡Evidencias subidas con éxito!"
          subTitle="El proceso ha finalizado correctamente. Ya puede cerrar esta ventana."
        />
      )}
    </div>
  );
};

export default CaptureSuccessPage;
